import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Platform } from '@angular/cdk/platform';
import { FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { environment } from '@environments/environment';

import { CookieService } from 'ngx-cookie-service';
import { DocumentosService } from '@app/shared/services';
import { MensagemService } from '@app/shared/services/mensagem.service';
import { CensoService } from '@app/shared/services/censo.service';

import { Censo } from '@app/shared/models';

import { ModalWebcamComponent } from '../modal-webcam/modal-webcam.component';

const MAX_SIZE_FILE_BITS = 20000000;

@Component({
  selector: 'app-modal-identidade',
  templateUrl: './modal-identidade.component.html',
  styleUrls: ['./modal-identidade.component.scss']
})
export class ModalIdentidadeComponent implements OnInit {

  @ViewChild('selfie') selfie: ElementRef<HTMLInputElement>;
  @ViewChild('videoSelfie') videoSelfie: ElementRef<HTMLInputElement>;

  arquivo: any = {};
  censo: Censo;
  cliente = environment.cliente;
  formDocs: FormGroup;

  formData: any = {
    selfie: null,
    carregandoSelfie: false,
    videoSelfie: null,
    carregandoVideo: false
  };

  constructor(
    private censoService: CensoService,
    public dialogRef: MatDialogRef<ModalIdentidadeComponent>,
    public dialog: MatDialog,
    readonly platform: Platform,
    private docsService: DocumentosService,
    private cookieService: CookieService,
    private mensagemService: MensagemService
  ) {
    this.censoService.buscarCenso(this.cliente.censo_id).subscribe(censo => this.censo = censo);

    if (this.cookieService.get('selfie') !== '' && this.cookieService.get('selfie') !== null) {
      this.formData.selfie = this.cookieService.get('selfie');
    }

    if (this.cookieService.get('videoSelfie') !== '' && this.cookieService.get('videoSelfie') !== null) {
      this.formData.videoSelfie = this.cookieService.get('videoSelfie');
    }
  }

  ngOnInit(): void { }

  get formValid(): boolean {
    return this.formData.selfie && this.formData.videoSelfie;
  }

  get isMobile(): boolean {
    return this.platform.ANDROID || this.platform.IOS;
  }

  onChangeFile(event: any): void {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      this.arquivo = fileList[0];
    }

    if (event.target.files && event.target.files.length <= 0) {
      return;
    }

    if (this.arquivo != null && this.arquivo.size > MAX_SIZE_FILE_BITS) {
      this.arquivo = null;
      return this.mensagemService.avisoMensagemAlerta(
        'Grave um vídeo menor, ou diminua a qualidade de vídeo da câmera.',
        'Arquivo de vídeo muito grande.'
      );
    }

    const file = event.target.files[0];

    if (event.currentTarget === this.selfie.nativeElement) {
      const tipo = file.type.split('/')[1];

      if (!['jpg', 'jpeg', 'png', 'pdf'].includes(tipo)) {
        this.arquivo = null;
        return this.mensagemService.avisoMensagemAlerta(
          'Arquivo não suportado',
        );
      }

      const formData = new FormData();
      formData.append('arquivo', this.arquivo);

      this.formData.carregandoSelfie = true;
      this.docsService
        .enviarDocumentoIdentificacao(formData, 'SELFIE').subscribe(() => {
          this.formData.selfie = formData;
          this.cookieService.set('selfie', 'enviado');
          this.formData.carregandoSelfie = false;
        }, (error) => {
          this.arquivo = null;
          this.formData.carregandoVideo = false;
          this.formData.carregandoSelfie = false;
          return this.mensagemService.avisoMensagemError();
        });
    }

    if (event.currentTarget === this.videoSelfie.nativeElement) {
      this.formData.carregandoVideo = true;

      const formData = new FormData();
      formData.append('arquivo', this.arquivo);

      this.docsService
        .enviarDocumentoIdentificacao(formData, 'VIDEO').subscribe(() => {
          this.formData.videoSelfie = formData;
          this.cookieService.set('videoSelfie', 'enviado');
          this.formData.carregandoVideo = false;
        }, (error) => {
          this.arquivo = null;
          this.formData.carregandoVideo = false;
          this.formData.carregandoSelfie = false;
          return this.mensagemService.avisoMensagemError();
        });
    }
  }

  back(): void {
    this.dialogRef.close();
  }

  closeModal(): void {
    this.dialogRef.close();
  }

  setSelfie(): void {
    if (this.isMobile) {
      this.selfie.nativeElement.click();
    } else {
      this.openWebCam('selfie');
    }
  }

  setVideoSelfie(): void {
    if (!this.formData.selfie) {
      return;
    }

    if (this.isMobile) {
      this.videoSelfie.nativeElement.click();
    } else {
      this.openWebCam('videoSelfie');
    }
  }

  openWebCam(propety: string): void {
    const dialogRef = this.dialog.open(ModalWebcamComponent, {
      panelClass: 'custom-phone-modal',
      closeOnNavigation: false,
      disableClose: true,
      data: { photo: propety === 'selfie' }
    });

    dialogRef.afterClosed().subscribe((file: any) => {
      if (file) {
        if (propety === 'selfie') {
          this.formData.carregandoSelfie = true;

          const blob = this.dataURLtoBlob(file);

          const formData = new FormData();
          formData.append('arquivo', blob);

          this.docsService
            .enviarDocumentoIdentificacao(formData, 'SELFIE').subscribe(() => {
              this.formData.carregandoSelfie = false;
              this.cookieService.set('selfie', 'enviado');
              this.formData.selfie = formData;
            });
        } else {
          this.formData.carregandoVideo = true;

          const formData = new FormData();
          formData.append('arquivo', file);

          this.docsService
            .enviarDocumentoIdentificacao(formData, 'VIDEO').subscribe(() => {
              this.formData.carregandoVideo = false;
              this.cookieService.set('videoSelfie', 'enviado');
              this.formData.videoSelfie = formData;
            });
        }
      }
    });
  }

  dataURLtoBlob(dataurl: any): any {
    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  }
}
